import { Box } from '@mui/material';

import { TP_OPTIONS_DIVIDER_LINE_SX, TP_OPTIONS_DIVIDER_SX } from '../styles';

export default function TpOptionsMenuDivider() {
  return (
    <Box component="li" role="separator" aria-hidden sx={TP_OPTIONS_DIVIDER_SX}>
      <Box sx={TP_OPTIONS_DIVIDER_LINE_SX} />
    </Box>
  );
}
